import api from "@/lib/api";

// Fire a single anonymous page-visit ping per browser session (used for landing-page analytics).
export function trackVisit(path) {
    try {
        let sid = localStorage.getItem("ssc_visitor_id");
        if (!sid) {
            sid = crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
            localStorage.setItem("ssc_visitor_id", sid);
        }
        if (sessionStorage.getItem("ssc_visit_tracked")) return;
        sessionStorage.setItem("ssc_visit_tracked", "1");
        api.post("/public/visit", {
            session_id: sid,
            path: path || window.location.pathname,
            referrer: document.referrer || "",
            url: window.location.href || "",
        }).catch(() => {});
    } catch (e) { /* non-blocking */ }
}
